import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardBody, CardHeader } from "reactstrap";
import { connect } from "react-redux";
import { setBreadcrumbItems } from "../../store/actions";
import { useParams } from "react-router-dom";
import Spinners from "components/Common/Spinner";
import * as url from "../../helpers/url_helper";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { MDBDataTable } from "mdbreact";
import { Link } from "react-router-dom";
import moment from "moment";
import { formatMobile, getAge } from "helpers/dob_helper";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";

const ViewMeetingDetail = (props) => {
  document.title = "Schedule Attendance Users - VUF";
  const { id } = useParams();

  const [userdataList, setUserdataList] = useState([]);
  const [DateRange, setDateRange] = useState({});
  const [SelectUser, setSelectUser] = useState({});
  const scheduleData = {
    title: "",
    description: "",
    start_date: "",
    end_date: "",
    start_time: "",
    end_time: "",
    schedule_time: "",
    schedule_type: "",
  };
  const [scheduleStatus, setScheduleStatus] = useState(scheduleData);
  const [totalUsers, setTotalUsers] = useState("0");

  const breadcrumbItems = [
    { title: "VUF", link: "#" },
    { title: "Schedule User List", link: "#" },
  ];

  const [isLoading, setLoading] = useState(false);
  const [scheduleDetails, setScheduleDetails] = useState({});
  const [copy, setCopy] = useState([]);

  useEffect(() => {
    props.setBreadcrumbItems("Schedule User List", breadcrumbItems);
  });

  useEffect(() => {
    getSchedule();
    //getUserScheduleAttendance();
  }, []);
  const formatTime = (timeString) => {
    if (!timeString) return "";
    const date = new Date(`1970-01-01T${timeString}`);
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  };
  function getSchedule() {
    let urlPath = "schedule/details/" + id;

    fetch(url.VUF_APP_API + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData.status) {
          var dataResponse = responseData.response;          
          setScheduleDetails(dataResponse.scheduleDetails);
          setUserdataList(dataResponse.AttendanceList);
          setCopy(dataResponse.AttendanceList);
          setTotalUsers(dataResponse.AttendanceList.length);
        } else {
          toast.error("Something went wrong, Please try again after sometime.");
        }
      })
      .catch((error) => {
        toast.error("Something went wrong, Please try again after sometime.");
      })
      .finally((final) => {
        setLoading(false);
      });
  }

  function exportToExcel(data) {
    var fileName = "AttendanceUser";
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `${fileName}.xlsx`);
  }

  const formattedEventList = userdataList.map((user) => ({
    ...user,
    firstName:
      user.userId?.lastName != null
        ? user.userId?.firstName + " " + user.userId?.lastName
        : user.userId.firstName,
    mobileNo: formatMobile(user.userId.countryCode, user.userId.mobileNo),
    date: user.date + " " + user.time,
    age: getAge(user.userId.dob, "---"),
    Address:
      user.userId.street_address == undefined ||
      (user.city != null &&
      user.userId.city != undefined &&
      user.userId.city != ""
        ? user.userId.city +
          ", " +
          user.userId.state +
          ", " +
          user.userId.country
        : "---") ||
      "---",
    Action: [
      <Link
        to={`/UserDetails/EventUsers_${id}/${user.userId._id}`}
        className="btn btn-info btn-sm  "
      >
        {" "}
        <span className="menu-text" style={{ color: "white" }}>
          {" "}
          <span className=" menu-icon fas fa fa-eye" style={{ color: "white" }}>
            {" "}
          </span>
        </span>{" "}
      </Link>,
    ],
  }));

  const tableData = {
    columns: [
      {
        label: "Name",
        field: "firstName",
        sort: "asc",
        width: 23,
      },
      {
        label: "Mobile no.",
        field: "mobileNo",
        sort: "asc",
        width: 10,
      },
      {
        label: "Date Time",
        field: "date",
        sort: "asc",
        width: 20,
      },
    ],
    rows: formattedEventList,
  };

  return (
    <React.Fragment>
      {isLoading ? (
        <Spinners />
      ) : (
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <Row>
                  {userdataList.length > 0 ? (
                    <div className="d-flex justify-content-end">
                      <button
                        className=" btn btn-success float-right"
                        onClick={(event) => exportToExcel(copy)}
                      >
                        Export to Excel
                      </button>
                    </div>
                  ) : (
                    ""
                  )}
                </Row>
              </CardHeader>
              <CardBody>
                <div className="card p-4 mb-4">
                  <h2 className="h4 mb-4">
                    Schedule Details:
                    <span className="fw-bold">{scheduleDetails.title}</span>
                  </h2>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <p className="text-muted mb-1">Schedule Title</p>
                      {scheduleDetails.title}
                    </div>
                    <div className="col-md-6">
                      <p className="text-muted mb-1">Schedule Description</p>
                      {scheduleDetails.description}
                    </div>
                    <div className="col-md-6">
                      <p className="text-muted mb-1">Schedule Status</p>
                      {scheduleDetails.schedule_status === "Cancelled" && (
                        <span className="badge bg-secondary">Expired</span>
                      )}
                      {scheduleDetails.schedule_status === "Ongoing" && (
                        <span className="badge bg-primary">Ongoing</span>
                      )}
                      {scheduleDetails.schedule_status === "Upcoming" && (
                        <span className="badge bg-info text-dark">
                          Upcoming
                        </span>
                      )}
                    </div>
                    <div className="col-md-6">
                      <p className="text-muted mb-1">Schedule Type</p>
                      {scheduleDetails.schedule_type === "Daily" && (
                        <span className="badge bg-secondary fw-semibold">
                          Daily
                        </span>
                      )}
                      {scheduleDetails.schedule_type === "Weekly" && (
                        <span className="badge bg-primary fw-semibold">
                          Weekly
                        </span>
                      )}
                      {scheduleDetails.schedule_type === "AlternateDay" && (
                        <span className="badge bg-info text-dark fw-semibold">
                          AlternateDay
                        </span>
                      )}
                    </div>

                    <div className="col-md-6">
                      <p className="text-muted mb-1">Schedule Date</p>
                      <p className="fw-semibold">
                        {moment(scheduleDetails.start_date).format(
                          "DD MMM YYYY"
                        )}{" "}
                        to{" "}
                        {moment(scheduleDetails.end_date).format("DD MMM YYYY")}
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p className="text-muted mb-1">Schedule Time</p>
                      <p className="fw-semibold">
                        {formatTime(scheduleDetails.start_time)} to{" "}
                        {formatTime(scheduleDetails.end_time)}
                      </p>
                    </div>

                    {/* User Count */}
                    <div className="col-md-6">
                      <p className="text-muted mb-1">User Count</p>
                      <p className="fw-semibold">{totalUsers}</p>
                    </div>
                  </div>
                </div>

                <div className="event-card">
                  <div className="row">
                    <h2 className="h4 mb-4">Manage User List</h2>
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label>Date Range:</label>
                        <Flatpickr
                          className="form-control d-block"
                          placeholder="Select the date range"
                          value={DateRange}
                          onChange={(e) => {
                            setDateRange(e);
                            //dateval(e);
                          }}
                          options={{
                            mode: "range",
                            dateFormat: "d-m-Y",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <MDBDataTable responsive striped bordered data={tableData} />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(ViewMeetingDetail);
